import { render, staticRenderFns } from "./AdditionalGive.vue?vue&type=template&id=c12b5d7a&scoped=true&"
import script from "./AdditionalGive.vue?vue&type=script&lang=js&"
export * from "./AdditionalGive.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalGive.vue?vue&type=style&index=0&id=c12b5d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12b5d7a",
  null
  
)

export default component.exports